import React from 'react';
import { Toaster } from 'react-hot-toast';
import MyQualificationTable from './MyQualificationTable';

const MyQualification = () => {
  return (
    <>
      <Toaster position="bottom-center" toastOptions={{ duration: 3000 }} />
      <MyQualificationTable />
    </>
  );
};

export default MyQualification;
